//
import Model from '@/models/Model'

/**
* This class describes a pch detail provider payment.
*
* @class      PchDetailProviderPayment (name)
*/
export default class PchDetailProviderPayment extends Model {

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_provider_debt_to_pay_has_invoice() {
    return this.getProperty('pch_provider_debt_to_pay.pch_purchase_invoice_id', false)
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_provider_debt_to_pay_number() {
    return this.pch_provider_debt_to_pay_has_invoice ? 
      this.getProperty('pch_provider_debt_to_pay.pch_purchase_invoice.invoice_number', '-')
      : 
      this.getProperty('pch_provider_debt_to_pay.pch_purchase_debit_note.number', '-')
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_provider_debt_to_pay_type() {
    return this.pch_provider_debt_to_pay_has_invoice ? 'Factura' : 'Nota de debito'
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_provider_debt_to_pay_total() {
    return this.pch_provider_debt_to_pay_has_invoice ? 
      this.getProperty('pch_provider_debt_to_pay.pch_purchase_invoice.total', 0)
      : 
      this.getProperty('pch_provider_debt_to_pay.pch_purchase_debit_note.total', 0)
  }

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pch_detail_provider_payment'
  }
}
